// src/components/LoginModal.tsx
import React, { useState } from 'react'

interface LoginModalProps {
  onLogin: (email: string, password: string) => Promise<{ success: boolean; error?: string }>
  onClose: () => void
  onSuccess: () => void
}

const SpinnerIcon: React.FC = () => (
  <svg
    className="spinner"
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M21 12a9 9 0 1 1-6.219-8.56" />
  </svg>
)

export function LoginModal({ onLogin, onClose, onSuccess }: LoginModalProps) {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    if (!email.trim() || !password) return

    setLoading(true)
    setError('')

    try {
      const result = await onLogin(email, password)
      setLoading(false)

      if (result.success) {
        onSuccess()
      } else {
        setError(result.error || 'Erro ao fazer login.')
      }
    } catch {
      setLoading(false)
      setError('Erro inesperado. Tente novamente.')
    }
  }

  return (
    <div className="login-overlay" onClick={onClose}>
      <div className="login-modal" onClick={(e) => e.stopPropagation()}>
        <button className="login-close" onClick={onClose} type="button">
          &times;
        </button>

        <h3 className="login-title">Entre na sua conta</h3>
        <p className="login-subtitle">
          Use seu e-mail e senha do Testfy Professionals
        </p>

        {error && <div className="login-error">{error}</div>}

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-field">
            <label className="form-label">E-mail</label>
            <input
              type="email"
              className="form-input"
              placeholder="seu@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoFocus
            />
          </div>
          <div className="form-field">
            <label className="form-label">Senha</label>
            <input
              type="password"
              className="form-input"
              placeholder="Sua senha"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <button type="submit" className="submit-btn" disabled={loading}>
            {loading ? (
              <>
                <SpinnerIcon /> Entrando...
              </>
            ) : (
              'Entrar e começar teste'
            )}
          </button>
        </form>

        <p className="login-signup">
          Não tem conta?{' '}
          <a
            href="https://pro.testfy.com.br/auth"
            className="login-signup-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            Criar conta
          </a>
        </p>
      </div>
    </div>
  )
}
